import { render } from "./RegistrationPanel.vue?vue&type=template&id=5a1c749e"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script